
<p-toast></p-toast>
<div class="card my-0 " reflow="true">
    <div class="flex align-items-center justify-content-center gap-4">
        <div class="field mb-0">
            <label for="date" class="mr-3" style="font-weight: 600;">{{'SELECT_DATE'| translate}}</label>
            <p-calendar
                [(ngModel)]="selectedDate"
                [showIcon]="true"
                inputId="date"
                (onChange)="dateChange()"
                [disabled]="showTabs"
            ></p-calendar>
        </div>
        <button *ngIf="!showTabs" pButton pRipple label="{{'SUBMIT'| translate}}" class="p-button-success ml-3" (click)="submitHandler()"></button>
        <button *ngIf="showTabs" pButton pRipple label="{{'CLEAR'| translate}}" class="p-button-warning ml-3" (click)="clearDate()"></button>
    </div>
</div>
<div  >
    <p-tabMenu *ngIf="showTabs" [model]="items" [activeItem]="items[0]" class="mb-2">
    </p-tabMenu>
    <router-outlet *ngIf="showTabs" ></router-outlet>
</div>

